(function($) {
	formHelper.addRule({
		form: '.form-edit-traveler',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR: function() { 
				lDialog.close() 
			}
		}
	});
})(jQuery);


jQuery(function initHandleEditTravlerForm($) {
	$('#form-edit-traveler').each(function(index, el) {

		var $container             = $(this);
		var $submitBtn		       = $container.find('.btn-submit');

		$submitBtn.click(function() {
			// Diaplay a lDialog loading shadow box
			checkValidityValue = $('#form-edit-traveler')[0].checkValidity(); // returns true/false

			if(checkValidityValue === true) {
				// Browser checkValidity is true, load loading ldialog shadow box
				launchLoadingDialog();
			}
		});
	});
});